import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ConfirmPayment from './ConfirmPayment'
import Modal from 'react-modal'
import { useQuery } from '@apollo/client'
import { GET_AMOUNT_FOR_SELECTED_PLAN } from '../../../../graphql/query'

interface IProps {
  closePaymentModal: any
  plan: any
  currentPlan: any
}

const PaymentDetailFill: React.FC<IProps> = ({ closePaymentModal, plan, currentPlan }) => {
  const [isConfirmPaymentModalOpen, setIsConfirmPaymentModalOpen] = useState<boolean>(false)
  const [cardHolderName, setCardHolderName] = useState<any>('')
  const [cardNumber, setCardNumber] = useState<any>()

  const { loading, error, data } = useQuery(GET_AMOUNT_FOR_SELECTED_PLAN, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId,
        packageFeatureId: plan?.packageFeatureId
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  }

  const validationSchema = Yup.object().shape({
    cardName: Yup.string().required('Name on Card is required'),
    cardNumber: Yup.string().required('Card Number is required'),
    cardExpiryMonth: Yup.string().required('Expiration Month is required'),
    cardExpiryYear: Yup.string().required('Expiration Year is required'),
    cardCVV: Yup.string().required('CVV is required')
  })

  const formik = useFormik({
    initialValues: {
      cardName: '',
      cardNumber: '',
      cardExpiryMonth: '',
      cardExpiryYear: '',
      cardCVV: '',
      saveCard: true
    },
    validationSchema,
    onSubmit: (values) => {
      setCardHolderName(values.cardName)
      setCardNumber(values.cardNumber)
      openConfirmPaymentModal()
      console.log('Form submitted:', values)
    }
  })

  const openConfirmPaymentModal = () => {
    setIsConfirmPaymentModalOpen(true)
  }

  const closeConfirmPaymentModal = () => {
    setIsConfirmPaymentModalOpen(false)
  }

  if (loading) {
    return <>Loading..</>
  }
  if (error) {
    console.log(error)
  }
  const isDisabled = !!error

  return (
    <div>
      <div className=''>
        <div className='modal-header'>
          <h2>Add Payment</h2>
          <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
            <i className='ki-duotone ki-cross fs-1'></i>
          </div>
        </div>

        <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
          {/* Your form */}
          <form
            id='kt_modal_new_card_form'
            className='form fv-plugins-bootstrap5 fv-plugins-framework'
            onSubmit={formik.handleSubmit}
          >
            {/* Name On Card */}
            <div className='d-flex flex-column mb-7 fv-row fv-plugins-icon-container'>
              <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                <span className='required'>Name On Card</span>
              </label>
              <input
                type='text'
                className='form-control form-control-solid'
                placeholder=''
                name='cardName'
                value={formik.values.cardName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={isDisabled}
              />
              {formik.touched.cardName && formik.errors.cardName && (
                <div className='fv-plugins-message-container invalid-feedback'>
                  {formik.errors.cardName}
                </div>
              )}
            </div>
            {/* Card Number */}
            <div className='d-flex flex-column mb-7 fv-row fv-plugins-icon-container'>
              <label className='required fs-6 fw-semibold form-label mb-2'>Card Number</label>
              <div className='position-relative'>
                <input
                  type='text'
                  className='form-control form-control-solid'
                  placeholder='Enter card number'
                  name='cardNumber'
                  value={formik.values.cardNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={isDisabled}
                />
                <div className='position-absolute translate-middle-y top-50 end-0 me-5'>
                  <img
                    src='	https://preview.keenthemes.com/metronic8/demo1/assets/media/svg/card-logos/visa.svg'
                    alt=''
                    className='h-25px'
                  />
                  <img
                    src='	https://preview.keenthemes.com/metronic8/demo1/assets/media/svg/card-logos/mastercard.svg'
                    alt=''
                    className='h-25px'
                  />
                  <img
                    src='https://preview.keenthemes.com/metronic8/demo1/assets/media/svg/card-logos/american-express.svg'
                    alt=''
                    className='h-25px'
                  />
                </div>
              </div>

              {formik.touched.cardNumber && formik.errors.cardNumber && (
                <div className='fv-plugins-message-container invalid-feedback'>
                  {formik.errors.cardNumber}
                </div>
              )}
            </div>
            {/* Expiration Date */}
            <div className='row mb-10'>
              <div className='col-md-8 fv-row'>
                <label className='required fs-6 fw-semibold form-label mb-2'>Expiration Date</label>
                <div className='row fv-row fv-plugins-icon-container'>
                  <div className='col-6'>
                    <select
                      name='cardExpiryMonth'
                      className='form-select form-select-solid'
                      value={formik.values.cardExpiryMonth}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={isDisabled}
                    >
                      <option value=''>Month</option>
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                    {formik.touched.cardExpiryMonth && formik.errors.cardExpiryMonth && (
                      <div className='fv-plugins-message-container invalid-feedback'>
                        {formik.errors.cardExpiryMonth}
                      </div>
                    )}
                  </div>
                  <div className='col-6'>
                    <select
                      name='cardExpiryYear'
                      className='form-select form-select-solid'
                      value={formik.values.cardExpiryYear}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={isDisabled}
                    >
                      <option value=''>Year</option>
                      {Array.from({ length: 11 }, (_, i) => (
                        <option key={2024 + i} value={2024 + i}>
                          {2024 + i}
                        </option>
                      ))}
                    </select>
                    {formik.touched.cardExpiryYear && formik.errors.cardExpiryYear && (
                      <div className='fv-plugins-message-container invalid-feedback'>
                        {formik.errors.cardExpiryYear}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-4 fv-row fv-plugins-icon-container'>
                <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                  <span className='required'>CVV</span>
                </label>
                <div className='position-relative'>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder='CVV'
                    name='cardCVV'
                    value={formik.values.cardCVV}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={isDisabled}
                  />
                  <div className='position-absolute translate-middle-y top-50 end-0 me-3'>
                    <i className='ki-duotone ki-credit-cart fs-2hx'></i>
                  </div>
                </div>
                {formik.touched.cardCVV && formik.errors.cardCVV && (
                  <div className='fv-plugins-message-container invalid-feedback'>
                    {formik.errors.cardCVV}
                  </div>
                )}
              </div>
            </div>

            <div className='d-flex flex-stack'>
              <div className='me-5'>
                <label className='fs-6 fw-semibold form-label'>
                  Save Card for further billing?
                </label>
                <div className='fs-7 fw-semibold text-muted'>
                  If you need more info, please check budget planning
                </div>
              </div>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  name='saveCard'
                  checked={formik.values.saveCard}
                  onChange={formik.handleChange}
                  disabled={isDisabled}
                />
                <span className='form-check-label fw-semibold text-muted'>Save Card</span>
              </label>
            </div>

            <div className='text-end pt-15'>
              <button
                id='kt_modal_new_card_cancel'
                className='btn btn-light me-3'
                onClick={closePaymentModal}
              >
                Cancel
              </button>
              <button
                type='submit'
                id='kt_modal_new_card_submit'
                className='btn btn-primary'
                disabled={!formik.isValid || isDisabled} // Disable button if form is invalid
              >
                <span className='indicator-label'>Submit</span>
                <span className='indicator-progress'>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <Modal
        isOpen={isConfirmPaymentModalOpen}
        onRequestClose={closeConfirmPaymentModal}
        style={customModalStyles}
        contentLabel='Confirm payment'
      >
        <ConfirmPayment
          closeConfirmPaymentModal={closeConfirmPaymentModal}
          closePaymentModal={closePaymentModal}
          plan={plan}
          currentPlan={currentPlan}
          cardHolderName={cardHolderName}
          cardNumber={cardNumber}
          data={data}
        />
      </Modal>
    </div>
  )
}

export default PaymentDetailFill
